
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 7393","xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7379","transform":"translate(7.343 10.086)","fill":"none","stroke":"#109a50","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Path 11374","d":"M35.466 8.734l-2.993-7.477A1.994 1.994 0 0030.619 0H15.34a1.994 1.994 0 00-1.854 1.257l-2.993 7.477a2 2 0 01-1.854 1.257h-6.64a2 2 0 00-2 2v23.978a2 2 0 002 2h41.962a2 2 0 002-2v-23.98a2 2 0 00-2-2h-6.64a2 2 0 01-1.855-1.255z"}}),_c('circle',{attrs:{"data-name":"Ellipse 623","cx":"11","cy":"11","r":"11","transform":"translate(12.657 9.914)"}})]),_c('path',{attrs:{"data-name":"Rectangle 5715","fill":"none","d":"M0 0h60v60H0z"}})])
          )
        }
      }
    